<template>
    <div class="chat">
        <div class="row">
            <h2 class="col">Guest Chat</h2>
        </div>

        <div class="row chat-content">
            <div class="col-4 chat-all-conv">
                <ul v-if="chats">
                    <li v-for="(chat, index) in chats.content" v-bind:key="index" v-on:click="selectChat(chat.reference)">
                        <div class="row">
                            <div class="col-2 chat-icon">
                                <i class="fas fa-user"></i>
                            </div>
                            <div class="col-10 chat-summ">
                                <div class="row">
                                    <div class="col-8 chat-summ--name">{{chat.guest.firstName}} {{chat.guest.lastName}}</div>
                                    <div class="col-4 chat-summ--date">{{smartTimeOrDate(chat.lastMessage.lastUpdated)}}</div>
                                    <div class="col-12">{{chat.lastMessage.content}}</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li v-if="chats.length === 0">
                        You don't yet have any chats with guests
                    </li>
                    <li v-if="canLoadMoreChats" class="text-center">
                      <button v-on:click="moreChats()" class="btn btn-secondary w-auto">More</button>
                    </li>
                </ul>
            </div>

            <div class="col-8 chat-conv-detail">
                <template v-if="selectedChat">
                    <div ref="messagesWindow" class="chat-conv-detail__messages-scrollable">

                        <div v-if="!selectedChat.messages.hasNext" class="text-center text-muted">
                            All messages loaded
                        </div>

                        <Spinner class="" v-show="loadingMessages"/>

                        <div class="chat-conv-detail__messages">
                            <div v-for="(message, index) in selectedChat.messages.content" v-bind:key="index">
                                <div class="message w-75 mb-3" v-bind:class="{'ml-auto' : message.host}">
                                    <div class="rounded py-2 px-3 mb-2" v-bind:class="{'bg-primary': message.host, 'bg-light' : message.guest}">
                                        <p class="text-small mb-0" v-bind:class="{'text-white' : message.host}">{{message.content}}</p>
                                    </div>
                                    <p class="small text-muted">{{friendlyChatTime(message.lastUpdated)}} | {{friendlyChatDateShort(message.lastUpdated)}}</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="chat-conv-detail__new-message-bar">
                        <template v-if="!errorSendingMessage">
                          <input type="text" v-model="newMessage" v-on:keyup.enter="sendMessage" ref="newMessage">
                          <div class="chat-conv-detail__new-message-bar__action">
                              <Spinner class="chat-conv-detail__new-message-bar__spinner" v-show="sendingMessage"/>
                              <button v-show="!sendingMessage"
                                      v-on:click="sendMessage"
                                      v-bind:class="{'btn-disabled' : !newMessage}"
                                      class="btn btn-primary"><i class="fas fa-paper-plane fa-rotate-by"></i></button>
                          </div>
                        </template>
                        <template v-else>
                          <div class="alert alert-danger w-100" role="alert">
                            {{errorSendingMessage}}
                            <button v-on:click="clearSendingMessageError()" class="close" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </template>
                    </div>
                </template>

                <template v-else>
                    <div class="chat-conv-detail--no-chat-selected">
                        <i class="fas fa-comments"></i>
<!--                        <i class="fab fa-whatsapp"></i>-->
                        <h3>WhatsApp chats by BetterGuest</h3>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from '../components/Spinner.vue'
    // import TripDetails from "../components/bookings/TripDetails";
    import { store } from '../store.js'

    import {datesMixin} from "../mixins/DatesMixin"

    export default {
        name: 'GuestChats',
        components: { Spinner },
        mixins: [datesMixin],
        data: function () {
            return {
                chats: null,
                selectedChat: null,
                loading: true,
                loadingMessages: false,
                chatPageNumber: 0,
                chatPageSize: 10,
                chatMessagesPageNumber: 0,
                chatMessagesPageSize: 10,
                newMessage: "",
                sendingMessage: false,
                errorSendingMessage: null,
                showTripDetails: false,
                trip: null,
            }
        },
        computed: {
          canLoadMoreChats: function () {
              if (this.chats && this.chats.hasNext) {
                return true;
              }
              return false;
          }
        },
        methods: {
            fetchPageOfChats: function (callback) {
                this.loading = true;
                let params = {
                    pageNumber: this.chatPageNumber,
                    pageSize: this.chatPageSize
                };
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats', {
                    params,
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            fetchFirstPageOfChats: function() {
                this.fetchPageOfChats((pageOfChats) => {
                    console.log(pageOfChats)
                    this.chats = pageOfChats;
                })
            },
            moreChats: function () {
                this.chatPageNumber++;
                console.log("fetching page of chats: " + this.chatPageNumber)
                this.fetchPageOfChats((pageOfChats) => {
                    console.log(pageOfChats)
                    this.chats.content.push(...pageOfChats.content)
                    this.chats.hasNext = pageOfChats.hasNext;
                    this.chats.hasPrevious = pageOfChats.hasPrevious;
                })
            },
            fetchChat: function (reference, callback) {
                this.loading = true;
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + reference, {
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            fetchPageOfMessages: function (callback) {
                this.loadingMessages = true;
                let params = {
                    pageNumber: this.chatMessagesPageNumber,
                    pageSize: this.chatMessagesPageSize
                };
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.selectedChat.reference + '/messages', {
                    params,
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loadingMessages = false
                })
            },
            selectChat: function(reference) {
                console.log("Selected chat " + reference);
                this.fetchChat(reference, (chat) => {
                    this.selectedChat = chat;
                    this.$nextTick(() => {
                        this.$refs.messagesWindow.addEventListener("scroll", this.scrollHandler);
                        this.scrollToEndOfChat();
                    });
                })
            },
            moreMessages: function () {
                if (this.selectedChat && this.selectedChat.messages.hasNext) {
                    console.log("fetching page of messages: " + this.chatMessagesPageNumber);
                    this.chatMessagesPageNumber++;
                    this.fetchPageOfMessages((pageOfMessages) => {
                        console.log(pageOfMessages)
                        this.selectedChat.messages.content.unshift(...pageOfMessages.content);
                        this.selectedChat.messages.hasNext = pageOfMessages.hasNext;
                    })
                }
            },
            scrollToEndOfChat: function() {
                this.$refs.messagesWindow.scrollTo(0, this.$refs.messagesWindow.scrollHeight);
            },
            scrollHandler: function() {
                console.log("Scrolling");
                let topOfWindow = this.$refs.messagesWindow.scrollTop === 0;
                if (topOfWindow) {
                    console.log("Scrolled to TOP");
                    this.moreMessages();
                }
            },
            sendMessage: function() {
                console.log("Sending message: " + this.newMessage);

                this.sendingMessage = true;

                const body = {
                    content: this.newMessage
                };

                this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.selectedChat.reference + '/send', body
                ).then(response => {
                    this.selectedChat.messages.content.push(response.data);
                    this.newMessage = "";
                    this.$refs.newMessage.focus();
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        this.errorSendingMessage = error.response.data.message;
                    } else {
                        this.errorSendingMessage = "There was a problem sending your message. Please try again.";
                    }
                }).finally(() => {
                    this.sendingMessage = false;
                });
            },
            clearSendingMessageError: function () {
                this.errorSendingMessage = null;
            },
            showTrip: function (booking) {
                this.trip = booking;
                this.showTripDetails = true;
            },
            hideTrip: function () {
                this.showTripDetails = false;
                this.trip = null;
            }
        },
        mounted() {
            console.log("Loading chats");
            this.fetchFirstPageOfChats();

            // this.$root.$on('selected-establishment', this.fetchFirstPageOfForms);
            // this.$root.$on('show-trip', this.showTrip);
            // this.$root.$on('finished-viewing-trip-details', this.hideTrip);
        },
        beforeDestroy () {
            if (this.$refs.messagesWindow) {
              this.$refs.messagesWindow.removeEventListener("scroll", this.scrollHandler);
            }
            // this.$root.$off('selected-establishment', this.fetchFirstPageOfForms);
            // this.$root.$off('show-trip', this.showTrip);
            // this.$root.$off('finished-viewing-trip-details', this.hideTrip);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/chat";
    @import "../styles/layout/forms.scss";
</style>